// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__gvts4","icon":"Loader_icon__B2R5a","rotating":"Loader_rotating__R1h1s"};